import { DEFAULT_COLUMNS_CONFIG } from '@/features/common/components/maintenance-table/MaintenanceTable';
import { ColumnConfig, RowStatusMapper } from '@/features/common/components/maintenance-table/types';
import { MaintenanceComponentDueState, MaintenanceDataItem } from '@/generated/GeneratedApiTypes';

const HEADER_PREFIX = 'intl-msg:vehicle-diagnostics.maintenance.table.header.maintenance-data';

export const MAINTENANCE_DATA_COLUMNS_CONFIG: ColumnConfig[] = [
    ...DEFAULT_COLUMNS_CONFIG,
    { name: 'due_state', labelKey: `${HEADER_PREFIX}.status`, sortingValue: 'status', hidden: false, sortable: true },
    {
        name: 'component',
        labelKey: `${HEADER_PREFIX}.component`,
        sortingValue: 'component',
        hidden: false,
        sortable: true,
    },
    { name: 'due_at', labelKey: `${HEADER_PREFIX}.due-at`, sortingValue: 'due_at', hidden: false, sortable: true },
    { name: 'due_in', labelKey: `${HEADER_PREFIX}.due-in`, sortingValue: 'due_in', hidden: false, sortable: true },
    {
        name: 'workshop_appointment',
        labelKey: `${HEADER_PREFIX}.workshop-appointment`,
        sortingValue: 'appointment',
        hidden: false,
        sortable: true,
    },
];

const DANGER_STATE: MaintenanceComponentDueState = 'OVERDUE';
const WARNING_STATE: MaintenanceComponentDueState = 'DUE';

export const statusMapper: RowStatusMapper = (row: MaintenanceDataItem) => {
    if (row.status === DANGER_STATE) {
        return 'danger';
    }
    if (row.status === WARNING_STATE) {
        return 'warning';
    }
    return '';
};
